function initAccordion() {
    $('.attrhead').off('click'); // Entferne alte Event-Listener, um doppelte Bindungen zu vermeiden
    $('.attrhead').on('click', function () {
        let attrcolElement = $(this).closest('.attrcol');
        $(this).next('.attrbody').toggleClass('activeAccordion');
        attrcolElement.toggleClass('attrcol_activ');
    });
}

// Initial einmal aufrufen
$(document).ready(function () {
    initAccordion();
});
